import React from "react";
import { styled } from "@mui/system";
import MUIRadioGroup from "@mui/material/RadioGroup";
import { RadioGroupProps } from "@mui/material/RadioGroup";

export const RadioGroup: (props: RadioGroupProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, RadioGroupProps>((props, ref) => (
    <MUIRadioGroup ref={ref} {...props} />
  )),
  {
    name: "RadioGroup",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({}));
